import { useButtonGroupContext } from '../../ButtonGroup/Context';
import whisper from '../../whisper';
import { deriveSize } from '../utils';
/**
 * Hook for determining which size value button should use.
 *
 * If button is inside of a ButtonGroup, uses the ButtonGroup-level
 * `buttonSize` prop over the button-level `size` prop.
 * If neither are specified, defaults to 'md'
 */
export var useDerivedSize = function (variant, size) {
    var buttonGroupContext = useButtonGroupContext();
    if (buttonGroupContext.buttonSize === 'sm' &&
        buttonGroupContext.inButtonGroup &&
        variant === 'link') {
        whisper.error({
            message: "Link variants cannot be used in ButtonGroups with buttonSize 'sm'",
        });
    }
    if (buttonGroupContext.inButtonGroup && !!size) {
        whisper.warn({
            message: "Link and Button component will ignore the size prop when inside a ButtonGroup",
        });
    }
    return deriveSize(buttonGroupContext, size);
};
//# sourceMappingURL=useDerivedSize.js.map